import styled from 'styled-components';

const CookingStyle = styled.section`
	--marginT: var(--sp9x);
	--gap: var(--sp6x);
	--cookingRelatedCookingItemsDistance: var(--sp9x);
	--relatedCookingItemMTop: var(--sp20x);

	.wrapper-cookings {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		gap: var(--gap);
		margin-top: var(--marginT);
	}

	.wrapper-related-titles {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.cooking-cooking-related-wrapper {
		margin-top: var(--cookingRelatedCookingItemsDistance);
	}

	.recipes-item-wrapper {
		height: fit-content;

		&:nth-child(even) {
			margin-top: var(--relatedCookingItemMTop);
		}
	}

	.wrapper-button {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginT: var(--sp8x);
		--gap: var(--sp4x);
		--relatedCookingItemMTop: var(--sp15x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp7x);
		--gap: var(--sp3x);
		--relatedCookingItemMTop: var(--sp12x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp6x);
		--gap: var(--sp2-5x);
		--relatedCookingItemMTop: var(--sp11x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginT: var(--sp5x);
		--relatedCookingItemMTop: var(--sp10x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp4x);
		--gap: var(--sp2x);
		--relatedCookingItemMTop: var(--sp8x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--relatedCookingItemMTop: var(--sp6x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gap: var(--sp1x);
		--relatedCookingItemMTop: var(--sp11x);

		.wrapper-cookings {
			grid-template-columns: 1fr 1fr;
			row-gap: var(--gap);
		}

		.wrapper-related-titles {
			flex-direction: column;
			align-items: start;
			gap: var(--sp3x);
		}
	}
`;

export default CookingStyle;
